import { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { RootState } from 'reducers';
import { connect } from 'react-redux';
import { Form} from "antd";
import { createEntity, getEntity, reset, updateEntity } from "./exchange.reducer";
import EditPage, { EditStateAndDispatchProps } from "layouts/page-wraper/edit-page-modal";
import { Exchange } from "model/procure/exchange.model";
export interface ExchangeEditProps extends EditStateAndDispatchProps<Exchange>, StateProps, DispatchProps, RouteComponentProps {
}

const ExchangeEdit: FC<ExchangeEditProps> = props => {
  const [form] = Form.useForm();
  return (
    <EditPage<Exchange>
      title="编辑"
      form={form}
      {...props}
    >
    </EditPage>);
};

const mapStateToProps = ({ exchange }: RootState) => ({
  entity: exchange.entity,
  updateSuccess: exchange.updateSuccess,
  updating: exchange.updating,
  createSuccess: exchange.createSuccess
});

const mapDispatchToProps = {
  getEntity,
  createEntity,
  updateEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeEdit);
